import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import { Book } from 'rebook/apps/books/models';
import pluralize from 'rebook/apps/utils/text/pluralize';
import BookReview from 'rebook/apps/books/components/BookReview';

import styles from './style.scss';


const getSortedReviewList = (reviews) => {
  let sortedReviews = {
    my: [],
    other: [],
  };

  if (!reviews || reviews.length === 0) {
    return sortedReviews;
  }

  reviews.map((item) => {
    const reviewBlock = (
      <li className={styles.item} key={item.id}>
        <div className={styles.bookReviewContainer}>
          <BookReview review={item} />
        </div>
      </li>
    );
    if (item.my_review) {
      sortedReviews.my.push(reviewBlock);
    }
    else {
      sortedReviews.other.push(reviewBlock);
    }
  });
  return sortedReviews;
};

const BookDetailReviewList = ({ reviews, book }) => {
  if (!reviews || reviews.length === 0) {
    return null;
  }
  const isAudioBook = get(book, 'type', '') === 'audio';
  const theBook = new Book(book);
  const title = book.reviews_count > 3
    ? (
      <Link to={theBook.getReviewsLink()}>
        <div className={styles.reviewTitle}>
          <div>
            <div className={styles.reviewTitleHeader}>
              <h2>
                Отзывы на {isAudioBook ? 'аудиокнигу' : 'книгу'}{' '}
                <span className={styles.titleBookName}>«{book.name}»</span>
              </h2>
            </div>
          </div>
          <div className={classNames(styles.link, 'link')}>
            <span className={styles.linkText}>
              <span className={styles.linkTextPrefix}>
                Всего &nbsp;
              </span>
              {book.reviews_count}&nbsp;
            </span>
            <span className={classNames('arrowRight', styles.arrow)} />
          </div>
        </div>
      </Link>
    )
    : (
      <div className={styles.reviewTitleHeader}>
        <h2>
          Отзывы на {isAudioBook ? 'аудиокнигу' : 'книгу'}{' '}
          <span className={styles.titleBookName}>«{book.name}»</span>
        </h2>
      </div>
    );

  const bookReviewList = getSortedReviewList(reviews);

  return (
    <div className={styles.reviewListWrapper}>
      <div className={styles.title}>
        {title}
      </div>
      <div>
        <ol>
          {bookReviewList.my.length > 0 && bookReviewList.my}
          {bookReviewList.other.length > 0 && bookReviewList.other}
        </ol>
      </div>
      {book.reviews_count > 3 && (
        <div className={styles.others}>
          <Link to={theBook.getReviewsLink()} className={styles.othersLink}>
            Еще {book.reviews_count - 3}&nbsp;{pluralize(book.reviews_count - 3, 'отзыв', 'отзыва', 'отзывов')}
          </Link>
        </div>
      )}
    </div>
  );
};

BookDetailReviewList.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      avatar: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
      comment: PropTypes.string.isRequired,
      book_rating: PropTypes.number.isRequired,
      submit_date: PropTypes.string.isRequired,
    })
  ),
};

export default BookDetailReviewList;
